<div fxFlex="1 1 auto"  #mapElement class="map-element">
  <div #popupElement class="popup"></div>
</div>

<app-infograph-map-legend fxFlex="none"  [graphicOptions]="graphicOptions"></app-infograph-map-legend>